<style scoped lang="scss">
@import '~variables';

.datatable_sort_wrapper {
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    .slot {
        white-space: nowrap;
    }

    .sort_icon {
        color: $gray-500;
        margin-left: .5rem;

        &.active {
            color: $black;
        }
    }
}
</style>

<template>
    <div class="datatable_sort_wrapper" @click="sort()">
        <span class="slot"><slot></slot></span>
        <div class="sort_icon" :class="{'active': field === search.sortField}">
            <span class="fas fa-sort" v-if="search.sortField !== field"></span>
            <span class="fas fa-sort-up" v-if="search.sortField === field && search.sortDirection === 'asc'"></span>
            <span class="fas fa-sort-down" v-if="search.sortField === field && search.sortDirection === 'desc'"></span>
        </div>
    </div>
</template>

<script>
    export default {

        props: {
            search: Object,
            field: {
                type: String,
                default: ''
            },
        },

        methods: {

            sort() {
                var direction = this.search.sortDirection === 'asc' ? 'desc' : 'asc';
                this.search.setSort(this.field, direction);
            },

        }
    }
</script>
